import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../../providers/index';

@Injectable()
export class NewOrderServiceProvider {
    newOrder : any = null;
    baseUrl: String = this.globalServiceProvider.appConfig.BaseApiTmsUrl;
    baseCustomerUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;
    constructor(
        public http: Http,
        public globalServiceProvider: GlobalServiceProvider,
    ) {
        console.log('Hello UserServiceProvider Provider');
    }

    get getNewOrder(): any {
        return this.newOrder;
    }
    set setNewOrder(valueObj: any) {
        this.newOrder = valueObj;
    }

    getNewOrderTabs(filter, condition) {
        let result = null;
        return this.http
            .get(this.baseUrl + "/orderbooking/", { params: { filter: filter, condition: condition } })
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch( err => {
                return null;
            });
    }

    getNewOrderTabsv2(data) {
        let result = null;
        return this.http
            .get(this.baseUrl + "/orderbookingtabs/", { params: data })
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch( err => {
                return null;
            });
    }

       
    getNewOrderTabsById(id) {
        let result = null;
        return this.http
            .get(this.baseUrl + "/orderbooking/" + id)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            }
            )
            .catch(
                err => {
                    return null;
                }
            );
    }

    getCustomerTransportLocation(customerNo) {
        console.log('url: ',this.baseUrl + '/tabs/getcustomertransportlocation/' + customerNo)
        let result = null;
        return this.http
            .get(this.baseUrl + '/tabs/getcustomertransportlocation/' + customerNo)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }

    getCustomerProduct(customerNo) {
        let result = null;
        return this.http
            .get(this.baseUrl + '/tabs/getcustomerproduct/' + customerNo)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }

    saveNewOrderTabs(postData) {
        let result = null;
        return this.http
            .post(this.baseUrl + '/orderbooking', postData)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }
    
    getOrderBookingByDate(postData) {
        let result = null;
        return this.http
            .post(this.baseUrl + '/orderbookingbydate', postData)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }

    updateNewOrderTabs(id, postData) {
        return this.http
            .put(this.baseUrl + "/v5/orderbooking/" + id, postData)
            .toPromise()
            .then((data: any) => {
                return data._body;
            }
            )
            .catch(
            err => {
                console.log('err: ', err);
                return null;
            }
        );
    }

    getCustomerByCustCode(custCode) {        
        let result = null;
        if(custCode){
            custCode = custCode.trim();
        }
        return this.http
            .get(this.baseUrl + '/tabs/getcustomer/' + custCode)
            .toPromise()
            .then(data => {
                console.log("data: ", data)
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }

    getOrderTabsByDate(data) {
        console.log('data: ', data);
        let result = null;
        return this.http
            .put(this.baseUrl + "/ordertabsbydate/bydate", data )
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(err => {
                return null;
            });
    }

    saveNewOrderTab(postData) {
        let result = null;
        return this.http
            .post(this.baseUrl + '/orderbookingv3', postData)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }

    newUpdateOrderBooking(postData) {
        let result = null;
        return this.http
            .post(this.baseUrl + '/newupdateorderbooking', postData)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(err => {
                return null;
            });
    }

    getCustomerEmails(postData) {
        let result = null;
        return this.http
            .post(this.baseUrl + '/customeremailsV2', postData)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(err => {
                return null;
            });
    }

    getOrderBookingPDF(postData) {
        let result = null;
        return this.http
            .post(this.baseUrl + '/v4/orderbooking/generatepdf', postData)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }
    
    async importOrderTabs(postData: any) {
        let result = null;
        try {
            const data = await this.http
                .post(this.baseUrl + '/v4/importorder', postData)
                .toPromise();
            result = data.json();
            return result;
        } catch (err) {
            console.log('err: ', err);
            return null;
        }
    }

    getLocationMapping(customerNo) {
        let result = null;
        return this.http
            .get(this.baseUrl + '/tabs/getlocationmapping/' + customerNo)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }

    async updateLocationmapping(postData: any) {
        let result = null;
        try {
            const data = await this.http
                .post(this.baseUrl + '/tabs/locationmapping', postData)
                .toPromise();
            result = data.json();
            return result;
        } catch (err) {
            console.log('err: ', err);
            return null;
        }
    }

    getProductMapping(customerNo) {
        let result = null;
        return this.http
            .get(this.baseUrl + '/tabs/getproductmapping/' + customerNo)
            .toPromise()
            .then(data => {
                result = data.json();
                return result;
            })
            .catch(
                err => {
                    console.log('err: ', err);
                    return null;
                }
            );
    }

    async updateProductmapping(postData: any) {
        let result = null;
        try {
            const data = await this.http
                .post(this.baseUrl + '/tabs/productmapping', postData)
                .toPromise();
            result = data.json();
            return result;
        } catch (err) {
            console.log('err: ', err);
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/new-order-service/new-order-service.ts